export default __webpack_public_path__ + "static/indoor3-6c9b4405e71d8a8ee2e9bf21374cb80c.webp";